import { MaybeList } from "Model/MaybeList";
import { IProject } from "Model/Storage/IProject";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasNoElements, toSafeArray } from "Utils/Array";
import { hasRelevantItems } from "Utils/Relevance";
import { projectsExportDialog } from "../../../Store/Actions";
import { selectSelectedOrActiveProjects } from "../../../Store/Selectors/Projects";
import { IAction } from "./IAction";

export function useExport(): [boolean, IAction] {
  const dispatch = useDispatch();
  const selectedProjects = useSelector(selectSelectedOrActiveProjects);
  const allowExport = isExportAllowed(selectedProjects);

  const onExport = useCallback(() => {
    if (!allowExport) {
      return;
    }
    dispatch(projectsExportDialog(true));
  }, [allowExport, dispatch]);

  return [allowExport, onExport];
}

function isExportAllowed(projectList: MaybeList<IProject>): boolean {
  const list = toSafeArray(projectList);
  if (hasNoElements(list)) {
    return false;
  }

  if (list.length > 10) {
    return false;
  }

  return list.every((project) => hasRelevantItems(project));
}
